import api from '../http/requests/api/index.js'


const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },
  setSelectedServices ({ commit }, services) {
    commit('SET_SELECTED_SERVICES', services)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo ({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
  checkTokenValid ({ commit }) {

    return new Promise((resolve, reject) => {
      api.checkToken()
        .then(response => {
          // If there's user data in response
          if (response.status === 200) {
            commit('SET_TOKEN_VALID', true)
            commit('UPDATE_USER_INFO', response.data)
            resolve(response)
          } else {
            commit('SET_TOKEN_VALID', false)
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  loginUser ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.loginUser(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful login')
            console.log(response.data)

            commit('SET_TOKEN_VALID', true)
            localStorage.accessToken = response.data.token
            resolve(response)
          } else {
            console.log('rejected')
            reject(response)
          }

        })
        .catch(error => {
          console.log(error.response.data)
          reject(error.response.data.error)
        })
    })
  },
  registerUser ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.registerUser(payload)
        .then(response => {

          console.log('respons', response)
          // If there's user data in response
          if (response.status === 200) {
            console.log('successful register')
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  registerUserCart ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.registerUserCart(payload)
        .then(response => {

          console.log('respons', response)
          // If there's user data in response
          if (response.status === 200) {
            console.log('successful register')
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  checkMail ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.checkMail(payload)
        .then(response => {

          console.log('respons', response)
          // If there's user data in response
          if (response.status === 200) {
            console.log('successful checkMail')
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  verifyPhone ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.verifyPhone(payload)
        .then(response => {
          // If there's user data in response
          if (response.status === 200) {
            console.log('successful verifyPhone', response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  resetPassword ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.resetPassword(payload)
        .then(response => {

          console.log('response', response)
          // If there's user data in response
          if (response.status === 200) {
            console.log('successful reset')
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error }) })
    })
  },
  checkResetToken ({ commit }, passtoken) {

    return new Promise((resolve, reject) => {
      api.getPassToken(passtoken)
        .then(response => {

          console.log('response', response)
          // If there's user data in response
          if (response.status === 200) {
            console.log('checking reset token')
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error }) })
    })
  },
  changePassword ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.changePassword(payload)
        .then(response => {

          console.log('response', response)
          // If there's user data in response
          if (response.status === 200) {
            console.log('successful change')
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error }) })
    })
  },
  savePost ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.savePost(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful post save', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  deleteInteraction ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.deleteInteraction(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful post delete', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  deletePost ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.deletePost(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful post delete', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  changeStatus ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.changeStatus(payload)
        .then(response => {
          // If there's user data in response
          if (response.status === 200) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  patchPost ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.patchPost(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful post save', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  patchUser ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.patchUser(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful user save', response.data)
            console.log(response.data)
            commit('UPDATE_USER_INFO', response.data.data)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.error }) })
    })
  },
  patchOtherUser ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.patchUser(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful user save', response.data)
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getPostDetail ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getPost(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('get post')
            console.log(response.data)

            commit('SET_POST_DETAIL', response.data.data)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getUser ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getUser(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('get user', response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getPostSlug ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getPostSlug(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('get post')
            console.log(response.data)

            commit('SET_POST_DETAIL', response.data.data)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getPostSlugUser ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getPostSlugUser(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('get post')
            console.log(response.data)

            commit('SET_POST_DETAIL', response.data.data)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  checkFingerPrint ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.checkFingerPrint(payload)
        .then(response => {
          if (response.status === 200) {
            commit('PASS', true)
            resolve(response.data)
          } else {
            reject({message: response})
          }
        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },

  getPosts ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getFeed(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('get post')
            console.log(response.data)

            commit('SET_POSTS', response.data)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getUsers ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getUsers(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('getUsers', response.data)

            commit('SET_USERS', response.data)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getInteractions ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getInteractions(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('get interactions')
            console.log(response.data)

            commit('SET_INTERACTIONS', response.data)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getInteractionsAll ({ commit }) {

    return new Promise((resolve, reject) => {
      api.getInteractionsAll()
        .then(response => {
          if (response.status === 200) {
            console.log('get interactions')
            console.log(response.data)

            commit('SET_INTERACTIONS_ALL', response.data)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  setInteraction ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.setInteraction(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('set interaction')
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getInteraction ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getInteraction(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('get interaction')
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getGame ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getGame(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('getGame')
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  setPlayed ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.setPlayed(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful interaction save', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  updateInteraction ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.updateInteraction(payload)
        .then(response => {
          // If there's user data in response
          if (response.status === 200) {
            commit('PASS', true)
            resolve(response.data)
          } else {
            reject({message: response})
          }
        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  sendReminder ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.sendReminder(payload)
        .then(response => {
          // If there's user data in response
          if (response.status === 200) {
            console.log('successful reminder sent', response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  sendReminderAll ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.sendReminderAll(payload)
        .then(response => {
          // If there's user data in response
          if (response.status === 200) {
            console.log('successful reminder sent', response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },

  registerCode ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.registerCode(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('successful register code', response.data)
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },

  getRewardsList ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getRewardsList(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('successful getRewardsList', response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },

  uploadImage ({commit}, payload, onUploadProgress) {
    return new Promise((resolve, reject) => {
      api.uploadImage(payload, onUploadProgress)
        .then(response => {
          console.log(response)
          if (response.data.data) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },


  saveService ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.saveService(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful saveService', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  deleteUser ({ commit }, id) {

    return new Promise((resolve, reject) => {
      api.deleteUser(id)
        .then(response => {
          // If there's user data in response
          if (response.status === 200) {
            console.log('successful deleteUser', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  deleteService ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.deleteService(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful deleteService', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  patchService ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.updateService(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful patchService', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getService ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getService(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('get service')
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getUserList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getUserList(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('getUserList')
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },

  getServiceList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getServiceList(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('getServiceList')
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },


  saveBundle ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.saveBundle(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful saveBundle', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  saveUser ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.saveUser(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful saveUser', response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  deleteBundle ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.deleteBundle(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful deleteBundle', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  patchBundle ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.updateBundle(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful patchBundle', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getBundle ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getBundle(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('getBundle')
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getBundleSlug ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getBundleSlug(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('getBundleSlug')
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getBundleList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getBundleList(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('getBundleList')
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },

  saveSale ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.saveSale(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful saveSale', response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  saveSaleMakePayment ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.saveSaleMakePayment(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful saveSaleMakePayment', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  newSaleMakePayment ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.newSaleMakePayment(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful newSaleMakePayment', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  deleteCard ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.deleteCard(payload)
        .then(response => {
          // If there's user data in response
          if (response.status === 200) {
            console.log('successful deleteCard', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  cancelSubscription ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.cancelSubscription(payload)
        .then(response => {
          // If there's user data in response
          if (response.status === 200) {
            console.log('successful cancelSubscriotion', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  deleteSale ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.deleteSale(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful deleteSale', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  patchSale ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.updateSale(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful patchSale', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getSale ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getSale(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('getSale')
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getSaleList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getSaleList(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('getSaleList')
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },

  getSubscriptions ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getSubscriptions(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('getSubscriptions')
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },

  getInvoice ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getInvoice(payload)
        .then(response => {
          if (response.status === 200) {
            console.log('getInvoice')
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },

  getPaymentIntent ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getPaymentIntent(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful getPaymentIntent', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  subscriptionPayment ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.subscriptionPayment(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful getPaymentIntent', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.error }) })
    })
  },

  getCardInfo ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getCardInfo(payload)
        .then(response => {
          // If there's user data in response
          if (response.status === 200) {
            console.log('successful getCardInfo', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  getUserCards ({ commit }) {

    return new Promise((resolve, reject) => {
      api.getUserCards()
        .then(response => {
          // If there's user data in response
          if (response.status === 200) {
            console.log('successful getUserCards', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  saveCard ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.saveCard(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful saveCard', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  saveCardForUser ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.saveCardForUser(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful saveCardForUser', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },
  makeDefault ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.makeDefault(payload)
        .then(response => {

          // If there's user data in response
          if (response.status === 200) {
            console.log('successful makePayment', response.data)
            console.log(response.data)

            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  }
}

export default actions
